/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listMediaPartners} from '../api'

export const useMutationListMediaPartners = createReactQueryMutationHook('listMediaPartners', listMediaPartners)
